import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../redux/actions/configApi'; // Assumindo que a API está configurada nesse arquivo
import { useNavigate } from "react-router-dom";

// AsyncThunk para buscar os posts
export const fetchPosts = createAsyncThunk(
    'posts/fetchPosts', // Corrigido o nome para seguir padrão de camelCase
    async (page, { rejectWithValue }) => {
        try {
            const response = await api.get(`/posts?page=${page}`); // Certifique-se de que a rota está correta
            return response.data; // Retorna os dados da resposta da API
        } catch (error) {
            // Trata erro e retorna mensagem personalizada ou erro da API
            return rejectWithValue(error.response?.data || 'Erro ao buscar posts');
        }
    }
)

export const fetchPostsHome = createAsyncThunk(
    'posts/fetchPostsHome', // Corrigido o nome para seguir padrão de camelCase
    async (page, { rejectWithValue }) => {
        try {
            const response = await api.get(`/postsHome?page=${page}`); // Certifique-se de que a rota está correta
            return response.data; // Retorna os dados da resposta da API
        } catch (error) {
            // Trata erro e retorna mensagem personalizada ou erro da API
            return rejectWithValue(error.response?.data || 'Erro ao buscar posts');
        }
    }
)

export const createPost = createAsyncThunk(
    'posts/createPost',
    async (formData, { rejectWithValue }) => {
        try {
            // Realiza o envio do FormData
            const response = await api.post('/postCreate', formData, {
               /* headers: {
                    'Content-Type': 'multipart/form-data', // Configuração necessária para FormData
                },*/
            });
            return response.data; // Retorna os dados do post criado
        } catch (error) {
            console.log(error?.response,'error')
            return rejectWithValue(error.response?.data || 'Erro ao criar post');
        }
    }
);
// AsyncThunk para atualizar um post
export const updatePost = createAsyncThunk(
    'posts/updatePost',
    async ({ id, formData }, { rejectWithValue }) => {
        try {
            const response = await api.post(`/post/${id}`, formData); // Envia os dados de atualização no body
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Erro ao atualizar o post');
        }
    }
);

export const deletePost = createAsyncThunk(
    'posts/deletePost',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.delete(`/postDelete/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
//Categoria
// Fetch - Obter categorias
export const fetchCatBlog = createAsyncThunk(
    'blog/fetchCatBlog',
    async (page, { rejectWithValue }) => {
        try {
            const response = await api.get(`cat-list?page=${page}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Erro ao buscar categorias');
        }
    }
);

// Create - Criar categoria
export const createCatBlog = createAsyncThunk(
    'blog/createCatBlog',
    async (categoria, { rejectWithValue }) => {
        try {
            const response = await api.post('storeCat', categoria);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Erro ao criar categoria');
        }
    }
);

// Update - Atualizar categoria
export const updateCatBlog = createAsyncThunk(
    'blog/updateCatBlog',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await api.put(`updateCat/${id}`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Erro ao atualizar categoria');
        }
    }
);

// Delete - Excluir categoria
export const deleteCatBlog = createAsyncThunk(
    'blog/deleteCatBlog',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.delete(`deleteCat/${id}`);
            return response.data; // Retornar o ID para remover do estado local
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Erro ao excluir categoria');
        }
    }
);

const blogSlice = createSlice({

    name: 'posts',
    initialState: {
        posts: [],
        loading: false,
        error: null,
        message: '',
        total: '',
        currentPage: 1,
        cats: [],
        loading2: false,
        error2: null,
        message2: '',

    },
    reducers: {}, // Não precisamos de reducers síncronos aqui
    extraReducers: (builder) => {
        builder
            // Fetch Vendas
            .addCase(fetchPosts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPosts.fulfilled, (state, action) => {
                state.loading = false;
                state.posts = action.payload.posts;
            })
            .addCase(fetchPosts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
               /* const navigate = useNavigate();
                if (action.payload?.message === "Unauthenticated.") {
                    navigate("/login"); // Use a navegação do React Router
                }*/
            })
            //Blog Home
            .addCase(fetchPostsHome.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPostsHome.fulfilled, (state, action) => {
                state.loading = false;
                state.posts = action.payload.posts;
            })
            
            // Update Post
            .addCase(updatePost.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updatePost.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload.message;
                state.posts = action.payload.posts

            })
            .addCase(updatePost.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                /* const navigate = useNavigate();
                 if (action.payload?.message === "Unauthenticated.") {
                     navigate("/login"); // Use a navegação do React Router
                 }*/
            })
            // Delete Post
            .addCase(deletePost.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deletePost.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload.message;
                state.posts = action.payload.posts

            })
            .addCase(deletePost.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                /*const navigate = useNavigate();
                if (action.payload?.message === "Unauthenticated.") {
                    navigate("/login"); // Use a navegação do React Router
                }*/
            })
            // Create Post
            .addCase(createPost.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createPost.fulfilled, (state, action) => {
                // alert('fulfilled')
                state.loading = false;
                state.message = action.payload.message;
                state.posts = action.payload.posts
            })
            .addCase(createPost.rejected, (state, action) => {
                state.loading = false;
                state.message = null;
                if (action.payload && action.payload.errors) {
                    // Caso o erro seja um objeto de validação, percorra os erros e mostre mensagens específicas
                    state.error = action.payload.errors;
                } else {
                    state.error = action.payload.message || 'Erro desconhecido';
                }
                console.log('Erro:', action.payload); // Log do erro
            });
            //categorias
            // Fetch
            builder.addCase(fetchCatBlog.pending, (state) => {
                state.loading2 = true;
                state.error = null;
            });
            builder.addCase(fetchCatBlog.fulfilled, (state, action) => {
                state.loading2 = false;
                state.cats = action.payload.cat;
            });
            builder.addCase(fetchCatBlog.rejected, (state, action) => {
                state.loading2 = false;
                state.error2 = action.payload;
              
            })
            // Create
            builder.addCase(createCatBlog.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
            });
            builder.addCase(createCatBlog.fulfilled, (state, action) => {
                state.loading2 = false;
                state.message2 = action.payload.message
                state.cats = action.payload.cat;
            });
            builder.addCase(createCatBlog.rejected, (state, action) => {
                state.loading2 = false;
                state.error2 = action.payload;
            });

            // Update
            builder.addCase(updateCatBlog.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
            });
            builder.addCase(updateCatBlog.fulfilled, (state, action) => {
                state.loading2 = false;
                state.message2 = action.payload.message
                state.cats = action.payload.cat;
            });
            builder.addCase(updateCatBlog.rejected, (state, action) => {
                state.loading2 = false;
                state.error2 = action.payload;
            });

            // Delete
            builder.addCase(deleteCatBlog.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
            });
            builder.addCase(deleteCatBlog.fulfilled, (state, action) => {
                state.loading2 = false;
                state.message2 = action.payload.message
                state.cats = action.payload.cat;
            });
            builder.addCase(deleteCatBlog.rejected, (state, action) => {
                state.loading2 = false;
                state.error2 = action.payload;
            });
    },
});

export default blogSlice.reducer;
